//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {MCancelIconName, MSuccessIconName, MIcon} from '../../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../../Toolkit/Components/Controls/Dialog';
import MButton from '../../Toolkit/Components/Controls/Button';
import {SendIconName} from '../SafeDigConstants';
import MFormControl from '../../Toolkit/Components/Controls/FormControl';
import MTextArea from '../Components/TextArea';

//endregion

/** */
type Props = {
    onDialogClose: (emailAddress: string[]) => void;
}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    addressData: string;
    data: SendData;
}

export type SendData = {
    estimate: string | undefined;
}

/** */
class JobSendDialog extends MComponent<Props, State> {

    private SendIcon: MIcon = {name: SendIconName, color: 'mcolor-info'};

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.yes_Click = this.yes_Click.bind(this);
        this.close_Click = this.close_Click.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        this.isSendDisabled = this.isSendDisabled.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            addressData: '',
            data: {
                estimate: ''
            }
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(estimate: string, prefill?: string[], position?: DialogPositionType) {
        let prefillText = '';
        if(prefill !== null && prefill !== undefined) {
            prefill.forEach((value: string, index: number, array: string[]) => {
                prefillText += value + (index < array.length - 1 ? '\n' : '');
            })
        }

        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.data.estimate = estimate;
            draft.addressData = prefillText;
        });

    }

    private yes_Click() {
        let addressString = this.state.addressData.replace(',',';');
        addressString = addressString.replace(/\n/g, ';');
        const addressArray = addressString.trim()
                                          .split(';')
                                          .filter(element => element.trim().length > 0)
                                          .map(address => address.trim());
        this.props.onDialogClose(addressArray);
        this.hide();
    }

    private close_Click() {
        this.hide();
    }

    private hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private isSendDisabled(): boolean {
        if(this.state.addressData !== null) {
            return !this.state.addressData!.match(/^([a-z0-9,!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9,!#$%&'*+/=?^_`{|}~-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*\.([a-z]{2,}))(\s*(;|,|\n)\s*[a-z0-9,!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9,!#$%&'*+/=?^_`{|}~-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*\.([a-z]{2,}))*$/g);
        }

        return true;
    }

    private getDialogTemplate(): ReactNode {
        return (
            <div className="formgrid grid">
                <p>
                    This will send job {this.state.data.estimate} to the address(es) entered below.
                    Multiple addresses should be entered on new lines or separated by semi-colons (;).
                </p>
                <br/>
                <br/>
                <div className="col-12 md:col-12">
                    <MFormControl label="E-mail addresses" id={'emailaddress'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MTextArea id={'addresses'}
                                           maxLength={200}
                                           disabled={false}
                                           initialValue={this.state.addressData}
                                           autoResize={true}
                                           cols={80}
                                           rows={10}
                                           onChange={e => this.safeSetState((draft: State) => draft.addressData = e!.toString())}
                                />
                            );
                        }}
                    </MFormControl>
                </div>
            </div>
        );
    }

    private getFooterTemplate(): ReactNode {
        return (
            <React.Fragment>
                <MButton label="Yes"
                         color="success"
                         icon={MSuccessIconName}
                         disabled={this.isSendDisabled}
                         onClick={this.yes_Click}/>
                <MButton label="Close"
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.close_Click}/>
            </React.Fragment>
        );
    }

    /** */
    public render(): ReactElement {

        return (
            <Dialog title={'Job Send'}
                    content={this.getDialogTemplate()}
                    icon={this.SendIcon}
                    footer={this.getFooterTemplate()}
                    position={this.state.position}
                    canClose={false}
                    closeOnEscape={false}
                    visible={this.state.visible}
                    onHide={this.dialog_onHide}/>
        );

    }

}

export default JobSendDialog;
